import React from 'react';
import { shape, string } from 'prop-types';
import Shimmer from '@magento/venia-ui/lib/components/Shimmer';
import defaultClasses from './breadcrumbs.module.css';
import { useMergeCssClasses } from '../../../../Utils/utils';

var BreadcrumbsShimmer = function BreadcrumbsShimmer(props) {
  var classes = useMergeCssClasses(defaultClasses, props.classes);
  return React.createElement("div", {
    className: classes.root,
    "aria-live": "polite",
    "aria-busy": "true"
  }, React.createElement(Shimmer, {
    width: 5
  }));
};

BreadcrumbsShimmer.propTypes = {
  classes: shape({
    root: string
  })
};
export default BreadcrumbsShimmer;